import React, { useState, useEffect } from "react";
import "react-multi-carousel/lib/styles.css";
import AllHeader from "../../../components/Navbar/AllHeader";
import Footer from "../../../components/footerPage/Footer";
import { useTranslation } from "react-i18next";
import { Row, Col } from "react-bootstrap";
import { Card, CardContent, Typography, Grid } from "@material-ui/core";
import BodyInformation from "./components/BodyInformation";
import BodyBooking from "./components/BodyBooking";
import BodyReview from "./components/BodyReview";
import BodyWhitelist from "./components/BodyWhitelist";
import { useLocation } from "react-router-dom";
import ProfileMenuSVG from "../../../components/card/profileMenuDetail";

function PersonalInfo() {
  const location = useLocation();
  const { state } = location;

  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // ใช้ localStorage เก็บค่า selectedComponent เพื่อเก็บข้าม reload
  const initialComponent =
    state?.selectedComponent ||
    localStorage.getItem("selectedComponent") ||
    "personal";

  const [selectedComponent, setSelectedComponent] = useState(initialComponent);

  useEffect(() => {
    if (state?.selectedComponent) {
      setSelectedComponent(state.selectedComponent);
    }
  }, [state]);

  // เก็บค่า selectedComponent ลง localStorage เวลาเปลี่ยน
  useEffect(() => {
    localStorage.setItem("selectedComponent", selectedComponent);
  }, [selectedComponent]);

  // ฟัง event จาก window (ถ้ามี component อื่นส่งค่า)
  useEffect(() => {
    const handleUpdateSelectedComponent = (event) => {
      setSelectedComponent(event.detail.selectedComponent);
    };
    window.addEventListener(
      "updateSelectedComponent",
      handleUpdateSelectedComponent
    );
    return () => {
      window.removeEventListener(
        "updateSelectedComponent",
        handleUpdateSelectedComponent
      );
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const renderSelectedComponent = () => {
    switch (selectedComponent) {
      case "personal":
        return <BodyInformation />;
      case "booking":
        return <BodyBooking />;
      case "review":
        return <BodyReview />;
      case "whitelist":
        return <BodyWhitelist />;
      default:
        return <BodyInformation />;
    }
  };

  return (
    <>
      <div>
        <AllHeader />
        <div className="container body-content-aa">
          <div className="row align-items-stretch">
            <div className="col-lg-1 order-md-1 d-none d-lg-block">
              {/* Content for the left column */}
            </div>
            <div className="col-lg-4 col-md-12 mb-4 d-flex justify-content-center">
              <div className="profile-menu-wrapper d-flex justify-content-center">
                <ProfileMenuSVG
                  onSelect={setSelectedComponent}
                  SelectNow={selectedComponent}
                />
              </div>
            </div>
            <div className="col-lg-6 text-center order-md-2 col-md-12 mb-4">
              {renderSelectedComponent()}
            </div>
            <div className="col-lg-1 order-md-3 d-none d-lg-block">
              {/* Content for the right column */}
            </div>
          </div>
        </div>
        <Footer />
      </div>

      {showScrollTop && (
        <button
          onClick={scrollToTop}
          aria-label="Scroll to top"
          className="scroll-to-top-btn"
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-4px)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
          }}
        >
          {/* Chevron Up */}
          <svg
            width="26"
            height="26"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="18 15 12 9 6 15" />
          </svg>
        </button>
      )}
    </>
  );
}

export default PersonalInfo;
